export default "__VITE_ASSET__DxOnGaMT__"